import { useCoins } from "./completion-queries";

export type Stage = {
    icon: string;
    label: string;
    value: number;
}

const stages: Stage[] = [
    { icon: '/img/Unranked.png', label: 'Unranked', value: 0 },
    { icon: '/img/Iron.png', label: 'Iron', value: 400 },
    { icon: '/img/Bronze.png', label: 'Bronze', value: 900 },
    { icon: '/img/Silver.png', label: 'Silver', value: 1500 },
    { icon: '/img/Gold.png', label: 'Gold', value: 2400 },
    { icon: '/img/Platin.png', label: 'Platinum', value: 3400 },
    { icon: '/img/Emerald.png', label: 'Emerald', value: 4400 },
    { icon: '/img/Diamond.png', label: 'Diamond', value: 5500 },
    { icon: '/img/Master.png', label: 'Master', value: 6750 },
    { icon: '/img/Grandmaster.png', label: 'Grandmaster', value: 8200 },
    { icon: '/img/Challenger.png', label: 'Challenger', value: 10000 },
];

export const useStage = () => {
    const { coins } = useCoins()
    const nextStage = stages.find((stage) => stage.value > coins)
    const currentStage = [...stages].reverse().find((stage) => stage.value <= coins)
    const prevStage = currentStage ? [...stages].reverse().find((stage) => stage.value < currentStage.value) : undefined

    const missingToNextStage = nextStage ? nextStage?.value - coins : 0;

    return { nextStage, missingToNextStage, stages, currentStage, prevStage }
}